export default {
   // Global
   tmpBackgroundColor: '#ddd',
   // tmpBodyTextColor: '#5d5151', // Dark Mode test
   tmpBodyTextColor: 'rgba(242, 225, 222, 0.4)', // Dark Mode test
   tmpColumnBorderColor: '#ddd',
   tmpNoteMetaTextColor: '#3d3d44',
   // Aside
   tmpAsideButtonActiveBackgroundColor: '#d5d5d5',
   tmpAsideLineColor: '#d5d5d5',
   // Content
   tmpContentBackgroundColor: '#141618', // Dark Mode test
   tmpContentLineColor: 'rgba(255,255,255,0.05)', // Dark Mode test
   // Main Menu
   tmpMainMenuBackgroundColor: '#101213',
   tmpMainMenuBorderColor: 'rgba(255,255,255,0.02)',
   tmpMainMenuButtonTextColor: '#625d5b',
   tmpMainMenuButtonActiveBackgroundColor: '#19191b',
   // tmpMainMenuLineColor: '#201c1a',  // Dark Mode test
   tmpMainMenuLineColor: '#1c1816',
   // tmpMainMenuTitleColor: '#c8c4bc'  // Dark Mode test
   tmpMainMenuTitleColor: '#827a7a'
}
